export default __webpack_public_path__ + "static/media/logo-apple-appstore.240112fa.svg";